export const ContactSlug = 'kontakt';

export function getContactFormUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${ContactSlug}`;
}
